module.exports = __webpack_public_path__ + "blue-bg.2d08e4d10b378e5d4723.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/assets/images/blue-bg.jpg
// module id = ../../../../../src/assets/images/blue-bg.jpg
// module chunks = styles